import { createAction } from "@reduxjs/toolkit";
import type { IMessageInfo } from "./messenger-models";

export namespace IMessengerActions {
  export enum Type {
    GET__FETCH_CHAT__INIT = "GET__FETCH_CHAT__INIT",
    GET__FETCH_CHAT__SUCCESS = "GET__FETCH_CHAT__SUCCESS",
    GET__FETCH_CHAT__FAILURE = "GET__FETCH_CHAT__FAILURE",
    GET__FETCH_CHAT__RESET = "GET__FETCH_CHAT__RESET",

    GET__FETCH_CHAT_RELOAD__INIT = "GET__FETCH_CHAT_RELOAD__INIT",
    GET__FETCH_CHAT_RELOAD__SUCCESS = "GET__FETCH_CHAT_RELOAD__SUCCESS",
    GET__FETCH_CHAT_RELOAD__FAILURE = "GET__FETCH_CHAT_RELOAD__FAILURE",

    POST__CREATE_CHAT__INIT = "POST__CREATE_CHAT__INIT",
    POST__CREATE_CHAT__SUCCESS = "POST__CREATE_CHAT__SUCCESS",
    POST__CREATE_CHAT__FAILURE = "POST__CREATE_CHAT__FAILURE",

    UPDATE__CHAT_BY_ID = "UPDATE__CHAT_BY_ID",

    GET__FETCH_MESSAGES__INIT = "GET__FETCH_MESSAGES__INIT",
    GET__FETCH_MESSAGES__SUCCESS = "GET__FETCH_MESSAGES__SUCCESS",
    GET__FETCH_MESSAGES__FAILURE = "GET__FETCH_MESSAGES__FAILURE",
    GET__FETCH_MESSAGES__RESET = "GET__FETCH_MESSAGES__RESET",
    GET__FETCH_NEXT_MESSAGES__INIT = "GET__FETCH_NEXT_MESSAGES__INIT",
    GET__FETCH_NEXT_MESSAGES__SUCCESS = "GET__FETCH_NEXT_MESSAGES__SUCCESS",
    GET__FETCH_NEXT_MESSAGES__FAILURE = "GET__FETCH_NEXT_MESSAGES__FAILURE",

    GET__MESSAGE_BY_ID__INIT = "GET__MESSAGE_BY_ID__INIT",
    GET__MESSAGE_BY_ID__SUCCESS = "GET__MESSAGE_BY_ID__SUCCESS",
    GET__MESSAGE_BY_ID__FAILURE = "GET__MESSAGE_BY_ID__FAILURE",

    GET__FROM_LAST_ID_MESSAGES__INIT = "GET__FROM_LAST_ID_MESSAGES__INIT",
    GET__FROM_LAST_ID_MESSAGES__SUCCESS = "GET__FROM_LAST_ID_MESSAGES__SUCCESS",
    GET__FROM_LAST_ID_MESSAGES__FAILURE = "GET__FROM_LAST_ID_MESSAGES__FAILURE",

    POST__SEND_MESSAGE__INIT = "POST__SEND_MESSAGE__INIT",
    POST__SEND_MESSAGE__SUCCESS = "POST__SEND_MESSAGE__SUCCESS",
    POST__SEND_MESSAGE__FAILURE = "POST__SEND_MESSAGE__FAILURE",

    POST__MESSAGE_WARNED__INIT = "POST__MESSAGE_WARNED__INIT",
    POST__MESSAGE_WARNED__SUCCESS = "POST__MESSAGE_WARNED__SUCCESS",
    POST__MESSAGE_WARNED__FAILURE = "POST__MESSAGE_WARNED__FAILURE",

    PATCH__BUY_PAID_CONTENT__INIT = "PATCH__BUY_PAID_CONTENT__INIT",
    PATCH__BUY_PAID_CONTENT__SUCCESS = "PATCH__BUY_PAID_CONTENT__SUCCESS",
    PATCH__BUY_PAID_CONTENT__FAILURE = "PATCH__BUY_PAID_CONTENT__FAILURE",
    PATCH__BUY_PAID_CONTENT__RESET = "PATCH__BUY_PAID_CONTENT__RESET",

    REMOVE__CLIENT_SIDE_MESSAGE = "REMOVE__CLIENT_SIDE_MESSAGE",

    ADD_CLIENT_SIDE_MESSAGE_RECEIVED = "ADD_CLIENT_SIDE_MESSAGE_RECEIVED",

    SET_CURRENT_ID = "SET_CURRENT_ID",

    // SET_FIRST_LOAD = 'SET_FIRST_LOAD',

    SET__PAID_CONTENT_CONFIG = "SET__PAID_CONTENT_CONFIG",

    SET_MESSENGER_POPUP = "SET_MESSENGER_POPUP",

    RESET__POST_SEND_MESSAGE = "RESET__POST_SEND_MESSAGE",

    UPDATE__MESSAGE_REVEAL_MEDIA = "UPDATE__MESSAGE_REVEAL_MEDIA",

    UPDATE__MESSAGE_AS_PAID = "UPDATE__MESSAGE_AS_PAID",

    UPDATE__MESSAGE_AS_HIDDEN = "UPDATE__MESSAGE_AS_HIDDEN",

    UPDATE__MESSAGE_AS_DELETED = "UPDATE__MESSAGE_AS_DELETED",

    UPDATE__MESSAGE = "UPDATE__MESSAGE",

    UPDATE__MESSAGE_AS_EXPIRED = "UPDATE__MESSAGE_AS_EXPIRED",

    UPDATE__MESSAGES_READ = "UPDATE__MESSAGES_READ",

    UPDATE__MESSAGES_DESTRUCTIBLE = "UPDATE__MESSAGES_DESTRUCTIBLE",

    UPDATE__SEND_MESSAGE_PROGRESS = "UPDATE__SEND_MESSAGE_PROGRESS",

    UPDATE__UNLOCK_BY_PAYING_USD = "UPDATE__UNLOCK_BY_PAYING_USD",

    POST__CHAT_NOTE__INIT = "POST__CHAT_NOTE__INIT",
    POST__CHAT_NOTE__SUCCESS = "POST__CHAT_NOTE__SUCCESS",
    POST__CHAT_NOTE__FAILURE = "POST__CHAT_NOTE__FAILURE",

    RESET__POST_CHAT_NOTE = "RESET__POST_CHAT_NOTE",

    PATCH__CHAT_NOTE__INIT = "PATCH__CHAT_NOTE__INIT",
    PATCH__CHAT_NOTE__SUCCESS = "PATCH__CHAT_NOTE__SUCCESS",
    PATCH__CHAT_NOTE__FAILURE = "PATCH__CHAT_NOTE__FAILURE",

    RESET__PATCH_CHAT_NOTE = "RESET__PATCH_CHAT_NOTE",

    DELETE__CHAT_NOTE__INIT = "DELETE__CHAT_NOTE__INIT",
    DELETE__CHAT_NOTE__SUCCESS = "DELETE__CHAT_NOTE__SUCCESS",
    DELETE__CHAT_NOTE__FAILURE = "DELETE__CHAT_NOTE__FAILURE",

    RESET__DELETE_CHAT_NOTE = "RESET__DELETE_CHAT_NOTE",

    DELETE__MESSAGE__INIT = "DELETE__MESSAGE__INIT",
    DELETE__MESSAGE__SUCCESS = "DELETE__MESSAGE__SUCCESS",
    DELETE__MESSAGE__FAILURE = "DELETE__MESSAGE__FAILURE",

    RESET__DELETE_MESSAGE = "RESET__DELETE_MESSAGE",

    PATCH__HIDE_MESSAGE__INIT = "PATCH__HIDE_MESSAGE__INIT",
    PATCH__HIDE_MESSAGE__SUCCESS = "PATCH__HIDE_MESSAGE__SUCCESS",
    PATCH__HIDE_MESSAGE__FAILURE = "PATCH__HIDE_MESSAGE__FAILURE",

    RESET__PATCH_HIDE_MESSAGE = "RESET__PATCH_HIDE_MESSAGE",

    POST__MESSAGE_REACTION__INIT = "POST__MESSAGE_REACTION__INIT",
    POST__MESSAGE_REACTION__SUCCESS = "POST__MESSAGE_REACTION__SUCCESS",
    POST__MESSAGE_REACTION__FAILURE = "POST__MESSAGE_REACTION__FAILURE",

    DELETE__MESSAGE_REACTION__INIT = "DELETE__MESSAGE_REACTION__INIT",
    DELETE__MESSAGE_REACTION__SUCCESS = "DELETE__MESSAGE_REACTION__SUCCESS",
    DELETE__MESSAGE_REACTION__FAILURE = "DELETE__MESSAGE_REACTION__FAILURE",

    SET__NOTE_TEXT = "SET__NOTE_TEXT",
    SET__EDITING_NOTE_ID = "SET__EDITING_NOTE_ID",
    SET__NOTES_OPEN = "SET__NOTES_OPEN",

    GET__CHAT_GALLERY__INIT = "GET__CHAT_GALLERY__INIT",
    GET__CHAT_GALLERY__SUCCESS = "GET__CHAT_GALLERY__SUCCESS",
    GET__CHAT_GALLERY__FAILURE = "GET__CHAT_GALLERY__FAILURE",

    GET__CHAT_GALLERY_NEXT__INIT = "GET__CHAT_GALLERY_NEXT__INIT",
    GET__CHAT_GALLERY_NEXT__SUCCESS = "GET__CHAT_GALLERY_NEXT__SUCCESS",
    GET__CHAT_GALLERY_NEXT__FAILURE = "GET__CHAT_GALLERY_NEXT__FAILURE",

    REMOVE_EXPIRED_FROM_CHAT_GALLERY = "REMOVE_EXPIRED_FROM_CHAT_GALLERY",
  }

  export const initGetChat = createAction<any>(Type.GET__FETCH_CHAT__INIT);
  export const successGetChat = createAction<any>(
    Type.GET__FETCH_CHAT__SUCCESS
  );
  export const failureGetChat = createAction<any>(
    Type.GET__FETCH_CHAT__FAILURE
  );
  export const resetGetChat = createAction(Type.GET__FETCH_CHAT__RESET);

  export const initGetChatReload = createAction<any>(
    Type.GET__FETCH_CHAT_RELOAD__INIT
  );
  export const successGetChatReload = createAction<any>(
    Type.GET__FETCH_CHAT_RELOAD__SUCCESS
  );
  export const failureGetChatReload = createAction<any>(
    Type.GET__FETCH_CHAT_RELOAD__FAILURE
  );

  export const initPostCreateChat = createAction<any>(
    Type.POST__CREATE_CHAT__INIT
  );
  export const successPostCreateChat = createAction<any>(
    Type.POST__CREATE_CHAT__SUCCESS
  );
  export const failurePostCreateChat = createAction<any>(
    Type.POST__CREATE_CHAT__FAILURE
  );

  export const updateChatById = createAction<any>(Type.UPDATE__CHAT_BY_ID);

  export const initGetMessages = createAction<any>(
    Type.GET__FETCH_MESSAGES__INIT
  );
  export const successGetMessages = createAction<any>(
    Type.GET__FETCH_MESSAGES__SUCCESS
  );
  export const failureGetMessages = createAction<any>(
    Type.GET__FETCH_MESSAGES__FAILURE
  );
  export const resetGetMessages = createAction(Type.GET__FETCH_MESSAGES__RESET);
  export const initGetNextMessages = createAction<any>(
    Type.GET__FETCH_NEXT_MESSAGES__INIT
  );
  export const successGetNextMessages = createAction<any>(
    Type.GET__FETCH_NEXT_MESSAGES__SUCCESS
  );
  export const failureGetNextMessages = createAction<any>(
    Type.GET__FETCH_NEXT_MESSAGES__FAILURE
  );

  export const initGetMessageById = createAction<any>(
    Type.GET__MESSAGE_BY_ID__INIT
  );
  export const successGetMessageById = createAction<any>(
    Type.GET__MESSAGE_BY_ID__SUCCESS
  );
  export const failureGetMessageById = createAction<any>(
    Type.GET__MESSAGE_BY_ID__FAILURE
  );

  export const initGetFromLastIdMessages = createAction(
    Type.GET__FROM_LAST_ID_MESSAGES__INIT
  );
  export const successGetFromLastIdMessages = createAction<any>(
    Type.GET__FROM_LAST_ID_MESSAGES__SUCCESS
  );
  export const failureGetFromLastIdMessages = createAction<any>(
    Type.GET__FROM_LAST_ID_MESSAGES__FAILURE
  );

  export const initPostSendMessage = createAction<any>(
    Type.POST__SEND_MESSAGE__INIT
  );
  export const successPostSendMessage = createAction<any>(
    Type.POST__SEND_MESSAGE__SUCCESS
  );
  export const failurePostSendMessage = createAction<any>(
    Type.POST__SEND_MESSAGE__FAILURE
  );

  export const initPostMessageWarned = createAction<any>(
    Type.POST__MESSAGE_WARNED__INIT
  );
  export const successPostMessageWarned = createAction<any>(
    Type.POST__MESSAGE_WARNED__SUCCESS
  );
  export const failurePostMessageWarned = createAction<any>(
    Type.POST__MESSAGE_WARNED__FAILURE
  );

  export const initPatchBuyPaidContent = createAction<any>(
    Type.PATCH__BUY_PAID_CONTENT__INIT
  );
  export const successPatchBuyPaidContent = createAction<any>(
    Type.PATCH__BUY_PAID_CONTENT__SUCCESS
  );
  export const failurePatchBuyPaidContent = createAction<any>(
    Type.PATCH__BUY_PAID_CONTENT__FAILURE
  );
  export const resetPatchBuyPaidContent = createAction(
    Type.PATCH__BUY_PAID_CONTENT__RESET
  );

  export const removeClientSideMessage = createAction<{
    __clientSideSendId: string;
  }>(Type.REMOVE__CLIENT_SIDE_MESSAGE);

  export const addClientSideMessageReceived = createAction<any>(
    Type.ADD_CLIENT_SIDE_MESSAGE_RECEIVED
  );

  // export const setCurrentId = createAction<any>(Type.SET_CURRENT_ID);

  // export const setFirstLoad = createAction<any>(Type.SET_FIRST_LOAD);

  export const setMessengerPopup = createAction<any>(Type.SET_MESSENGER_POPUP);

  export const togglePaidContent = createAction<any>(
    Type.SET__PAID_CONTENT_CONFIG
  );

  export const resetPostSendMessage = createAction(
    Type.RESET__POST_SEND_MESSAGE
  );

  export const updateMessageRevealMedia = createAction<any>(
    Type.UPDATE__MESSAGE_REVEAL_MEDIA
  );

  export const updateMessageAsPaid = createAction<any>(
    Type.UPDATE__MESSAGE_AS_PAID
  );

  export const updateMessageAsHidden = createAction<{
    hiddenMessage: IMessageInfo;
  }>(Type.UPDATE__MESSAGE_AS_HIDDEN);

  export const updateMessageAsDeleted = createAction<{
    deletedMessage: IMessageInfo;
  }>(Type.UPDATE__MESSAGE_AS_DELETED);

  export const updateMessage = createAction<{
    message: IMessageInfo;
  }>(Type.UPDATE__MESSAGE);

  export const updateMessageAsExpired = createAction<{
    messageId: string;
  }>(Type.UPDATE__MESSAGE_AS_EXPIRED);

  export const updateMessagesRead = createAction<any>(
    Type.UPDATE__MESSAGES_READ
  );

  export const updateSendMessageProgress = createAction<any>(
    Type.UPDATE__SEND_MESSAGE_PROGRESS
  );

  export const updateMessageUnlockByPayingUsd = createAction<any>(
    Type.UPDATE__UNLOCK_BY_PAYING_USD
  );

  export const initPostChatNote = createAction(Type.POST__CHAT_NOTE__INIT);
  export const successPostChatNote = createAction<any>(
    Type.POST__CHAT_NOTE__SUCCESS
  );
  export const failurePostChatNote = createAction<any>(
    Type.POST__CHAT_NOTE__FAILURE
  );

  export const resetPostChatNote = createAction(Type.RESET__POST_CHAT_NOTE);

  export const initPatchChatNote = createAction(Type.PATCH__CHAT_NOTE__INIT);
  export const successPatchChatNote = createAction<any>(
    Type.PATCH__CHAT_NOTE__SUCCESS
  );
  export const failurePatchChatNote = createAction<any>(
    Type.PATCH__CHAT_NOTE__FAILURE
  );

  export const resetPatchChatNote = createAction(Type.RESET__PATCH_CHAT_NOTE);

  export const initDeleteChatNote = createAction(Type.DELETE__CHAT_NOTE__INIT);
  export const successDeleteChatNote = createAction<any>(
    Type.DELETE__CHAT_NOTE__SUCCESS
  );
  export const failureDeleteChatNote = createAction<any>(
    Type.DELETE__CHAT_NOTE__FAILURE
  );

  export const resetDeleteChatNote = createAction(Type.RESET__DELETE_CHAT_NOTE);

  export const initDeleteMessage = createAction(Type.DELETE__MESSAGE__INIT);
  export const successDeleteMessage = createAction<any>(
    Type.DELETE__MESSAGE__SUCCESS
  );
  export const failureDeleteMessage = createAction<any>(
    Type.DELETE__MESSAGE__FAILURE
  );

  export const resetDeleteMessage = createAction(Type.RESET__DELETE_MESSAGE);

  export const initPatchHideMessage = createAction(
    Type.PATCH__HIDE_MESSAGE__INIT
  );
  export const successPatchHideMessage = createAction<any>(
    Type.PATCH__HIDE_MESSAGE__SUCCESS
  );
  export const failurePatchHideMessage = createAction<any>(
    Type.PATCH__HIDE_MESSAGE__FAILURE
  );

  export const resetPatchHideMessage = createAction(
    Type.RESET__PATCH_HIDE_MESSAGE
  );
  export const initPostMessageReaction = createAction<any>(
    Type.POST__MESSAGE_REACTION__INIT
  );
  export const successPostMessageReaction = createAction<any>(
    Type.POST__MESSAGE_REACTION__SUCCESS
  );
  export const failurePostMessageReaction = createAction<any>(
    Type.POST__MESSAGE_REACTION__FAILURE
  );

  export const initDeleteMessageReaction = createAction<any>(
    Type.DELETE__MESSAGE_REACTION__INIT
  );
  export const successDeleteMessageReaction = createAction<any>(
    Type.DELETE__MESSAGE_REACTION__SUCCESS
  );
  export const failureDeleteMessageReaction = createAction<any>(
    Type.DELETE__MESSAGE_REACTION__FAILURE
  );

  export const setNoteText = createAction<string>(Type.SET__NOTE_TEXT);
  export const setEditingNoteId = createAction<string | null>(
    Type.SET__EDITING_NOTE_ID
  );
  export const setNotesOpen = createAction<boolean>(Type.SET__NOTES_OPEN);

  export const initGetChatGallery = createAction(Type.GET__CHAT_GALLERY__INIT);
  export const successGetChatGallery = createAction<any>(
    Type.GET__CHAT_GALLERY__SUCCESS
  );
  export const failureGetChatGallery = createAction<any>(
    Type.GET__CHAT_GALLERY__FAILURE
  );

  export const initGetChatGalleryNext = createAction(
    Type.GET__CHAT_GALLERY_NEXT__INIT
  );
  export const successGetChatGalleryNext = createAction<any>(
    Type.GET__CHAT_GALLERY_NEXT__SUCCESS
  );
  export const failureGetChatGalleryNext = createAction<any>(
    Type.GET__CHAT_GALLERY_NEXT__FAILURE
  );

  export const removeExpiredFromChatGallery = createAction<{
    messageId: string;
  }>(Type.REMOVE_EXPIRED_FROM_CHAT_GALLERY);
}

export type MessengerActions = Omit<typeof IMessengerActions, "Type">;
